'use strict';

import defaultTemplate from '../../core/default.html';
import challengesListTemplate from './challenges.list.html';
import challengesNewTemplate from './challenges.new.html';
import challengesDemandTemplate from './challenges.demand.html';
import challengesParticipantsTemplate from './challenges.participants.html';
import challengesWeatherTemplate from './challenges.weather.html';
import challengesEventsTemplate from './challenges.events.html';

import Challenges from './challenges.ctrl';

function ChallengesRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.challenges', {
      url: '/challenges',
      template: defaultTemplate,
      resolve: {
        permission: function($q, utils) {
          const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
          let orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
          let hasFeatureC = utils.hasFeature(orgInfo, 'c');
          return hasFeatureC ? $q.resolve() : $q.reject();
        }
      }
    })
    .state('main.challenges.list', {
      url: '/list',
      template: challengesListTemplate,
      controller: 'ChallengesListController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIViewChallengeList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.challenges.list');
        }
      }
    })
    .state('main.challenges.new', {
      url: '/new',
      template: challengesNewTemplate,
      controller: 'ChallengesNewController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canICreateChallenge()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.challenges.new');
        }
      }
    })
    .state('main.challenges.demand', {
      url: '/demand/:id?:tab',
      template: challengesDemandTemplate,
      controller: 'ChallengesDemandController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIEditChallenge()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.challenges.demand');
        }
      }
    })
    .state('main.challenges.demand.more', {
      url: '/more',
      views: {
        'participants': {
          template: challengesParticipantsTemplate,
          controller: 'ChallengesParticipantsController as vm'
        },
      }
    })
    .state('main.challenges.weather', {
      url: '/weather/:id?:tab',
      template: challengesWeatherTemplate,
      controller: 'ChallengesWeatherController as vm'
    })
    .state('main.challenges.weather.more', {
      url: '/more',
      views: {
        'events': {
          template: challengesEventsTemplate,
          controller: 'ChallengesEventsController as vm'
        }
      }
    });
}

export default angular
  .module('challenges.router', [
    Challenges
  ])
  .config(ChallengesRouter)
  .name;
